export const WorksheetChecklistPanelTestIds = {
  PANEL: 'worksheet-checklist-panel',
  TITLE: 'worksheet-checklist-panel.title',
};
